import Dashboard from "../page/Dashboard/Dashboard";
import Login from "../page/Login/Login";
import Users from "../page/Users/Users";
import UsersDetail from "../page/Users/UsersDetail";
import ChangePassword from "../page/ChangePassword/ChangePassword";
import Coach from "../page/Coach/Coach";
import CoachDetail from "../page/Coach/CoachDetail";
import Language from "../page/Language/Language";
import CoachingSpecialities from "../page/CoachingSpecialities/CoachingSpecialities";
import CoachingAccreditation from "../page/CoachingAccreditation/CoachingAccreditation";
import Currency from "../page/Currency/Currency";

export const 
liveURL = "/";

export const publicRouters = [
  { path: "/", element: <Login /> },
  { path: "/login", element: <Login /> },
];

export const privateRouters = [
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/coachee", element: <Users /> },
  { path: "/coacheedetail/:id", element: <UsersDetail /> },
  { path: "/changepassword", element: <ChangePassword /> },
  { path: "/coach", element: <Coach /> },
  { path: "/coachdetail/:id", element: <CoachDetail /> },
  { path: "/language", element: <Language /> },
  { path: "/coachingspecialities", element: <CoachingSpecialities /> },
  { path: "/coachingaccreditation", element: <CoachingAccreditation /> },
  { path: "/currency", element: <Currency /> }
];